export default {
  openButton: 'Generar con IA',
  openButtonFill: 'Completar {entity} con IA',
  title: 'Generar {entity} con IA',
  subtitleSetup: 'Paso 1 de 2 · Elige la escala y qué criterios se redactan',
  subtitleReview: 'Paso 2 de 2 · Revisa la matriz antes de crearla',
  close: 'Cerrar',
  back: 'Volver',

  // Paso 1
  fromDesign: 'Del Diseño Instruccional: "{piece}"',
  titleLabel: 'Nombre de la Pauta',
  titlePlaceholder: 'Ej: Pauta del informe de caso',
  presetLabel: 'Modelo de Pauta',
  levelsSummary: '{count} niveles:',
  levelsMissing:
    'Este Modelo de Pauta no tiene niveles de desempeño, así que no hay celdas que escribir.',
  themeLabel: 'Tema u orientación (opcional)',
  themePlaceholder: 'Ej: evaluar sobre el informe de la cadena de frío',
  themeHint: 'Orienta sobre qué situar los criterios',
  themeInfo:
    'Acota el contexto de los criterios, sin cambiar lo que miden: el producto concreto que se evalúa, un escenario o un énfasis. Ej: "sobre el informe escrito", "en la ejecución en taller". No es un espacio para dar instrucciones.',
  criteriaTitle: 'Criterios ({entity})',
  criteriaHint:
    'Una dimensión por fila, con el o los {entity} que mide: una dimensión integradora puede medir varios. Lo que la IA escribe es el criterio y las celdas de cada nivel; los niveles y las ponderaciones no los decide la IA.',
  colWeighing: 'Ponderación',
  addRow: 'Agregar una dimensión',
  removeRow: 'Quitar la dimensión',
  rowsEmpty: 'No hay ninguna dimensión. Agrega una y elige qué Indicadores mide.',
  distribute: 'Repartir 100% entre las dimensiones',
  weighingTotal: 'Total: {total}%',
  weighingOfCriteria: 'Tope {total}%',
  weighingExisting: 'Ya ponderan {total}% en {count} dimensiones',

  // Paso 2
  streaming: 'Redactando... {done} de {total} criterios',
  reviewHint:
    '{count} criterios propuestos. Nada se ha guardado todavía: descarta los que no sirvan y crea el resto.',
  reviewEmpty: 'No quedó ningún criterio para revisar.',
  discard: 'Descartar',
  restore: 'Recuperar',

  // Acciones
  generate: 'Generar {count}',
  save: 'Crear la Pauta con {count} criterios',
  saveFill: 'Agregar {count} criterios',
  saved: 'Se guardaron {count} criterios.',
  savingProgress: 'Guardando... {done} de {total}',

  // Errores
  generateError:
    'Ocurrió un error al generar la pauta con IA. Intenta nuevamente.',
  generateEmpty:
    'La IA no propuso ningún criterio completo. Un criterio al que le falta una celda se descarta: una pauta con un casillero vacío no se puede usar para evaluar. Intenta nuevamente.',
  noCriterias:
    'Esta evaluación no declara ningún {entity}, que es lo que los criterios vienen a medir. Decláralos en el Diseño Instruccional y vuelve a intentar.',
}
